import { NullReferenceError } from "./exception/null-reference-error";
import { InvalidParameterError } from "./exception/invalid-parameter-error";
import { Logger } from "../logger/logger";

export class Converter {
	public static toInt(source: any) {
		if (source == null) {
			throw new InvalidParameterError("source", InvalidParameterError.nullText);
		}
		let sourceAsString = source.toString();
		let result = parseInt(sourceAsString, 10);
		if (Number.isNaN(result)) {
			Logger.error(`Could not convert attribute ${sourceAsString} to int`, source);
		}
		return result;
	}

	public static toFloat(source: any) {
		if (source == null) {
			throw new InvalidParameterError("source", InvalidParameterError.nullText);
		}
		let sourceAsString = source.toString();
		let result = parseFloat(sourceAsString);
		if (Number.isNaN(result)) {
			Logger.error(`Could not convert attribute ${sourceAsString} to float`, source);
		}
		return result;
	}

	public static toBool(source: any) {
		if (source == null) {
			throw new InvalidParameterError("source", InvalidParameterError.nullText);
		}
		let str = source.toString();
		str = str && str.toLowerCase();

		let result: boolean;
		if (str === "false") {
			result = false;
		} else if (str === "true") {
			result = true;
		} else {
			Logger.error(`Could not convert attribute ${str} to bool`, source);
		}
		return result;
	}

	public static toBoolOrDefault(source: any, defaultValue: boolean = false) {
		try {
			return Converter.toBool(source);
		} catch (err) {
			return defaultValue;
		}
	}

	public static toIntOrDefault(source: any, defaultValue: number = 0) {
		try {
			let result = Converter.toInt(source);
			if (!isNaN(result)) {
				return result;
			}
		} catch (err) {
			Logger.warn("Could not convert value to int", source, err);
		}
		return defaultValue;
	}

	public static toFloatOrDefault(source: any, defaultValue: number = 0) {
		try {
			let result = Converter.toFloat(source);
			if (!isNaN(result)) {
				return result;
			}
		} catch (err) {
			Logger.warn("Could not convert value to float", source, err);
		}
		return defaultValue;
	}
}